import loadScript from '@/azure/loader';
import { initGA } from '@/azure/analytics/ga/init';

loadScript(initGA);
